import { render, staticRenderFns } from "./wzzj5.vue?vue&type=template&id=13a5342b&scoped=true&"
import script from "./wzzj5.vue?vue&type=script&lang=js&"
export * from "./wzzj5.vue?vue&type=script&lang=js&"
import style0 from "./wzzj5.vue?vue&type=style&index=0&id=13a5342b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a5342b",
  null
  
)

export default component.exports